const beige = "#f8f3ea";
const black = "#373b3f";
const grey = "#5e5b62";
const lightgrey = "#98a0a9";
const orange = "#bf9540";
const white = "#ffffff";

export default { beige, black, grey, lightgrey, orange, white };
